import { Star } from "lucide-react";

export function Stars({ value = 0, size = 14, className = "" }) {
  const rounded = Math.round(value);
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} size={size} strokeWidth={1.5} className={n <= rounded ? "fill-ink text-ink" : "text-ink/25"} />
      ))}
    </span>
  );
}

export function StarInput({ value = 0, onChange, size = 22 }) {
  return (
    <span className="inline-flex items-center gap-1" data-testid="review-star-input">
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" onClick={() => onChange(n)} data-testid={`review-star-${n}`} className="transition-transform hover:scale-110" aria-label={`${n} star`}>
          <Star size={size} strokeWidth={1.5} className={n <= value ? "fill-ink text-ink" : "text-ink/25"} />
        </button>
      ))}
    </span>
  );
}
